"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var subscription_1 = require("../../../api/subscription");
var AutoComplete_1 = require("../../AutoComplete");
var pricing_1 = require("../../../api/pricing");
var AddNewLicense = function (props) {
    var buttonLabel = props.buttonLabel, className = props.className, companyId = props.companyId, userId = props.userId;
    var _a = react_1.useState(false), modal = _a[0], setModal = _a[1];
    var _b = react_1.useState(''), unit = _b[0], setUnit = _b[1];
    var toggle = function () { return setModal(!modal); };
    var autoRef = react_1.useRef();
    var getLicenses = function () {
        pricing_1.fetchLicenses().then(function (response) {
            console.log('responselist');
            console.log(response.list);
            autoRef.current.setSearchResult(response.list.map(function (item) {
                var newItem = {
                    key: item.name,
                    value: item.licenseId,
                    label: item.name
                };
                return newItem;
            }));
        }).catch(console.error);
    };
    //const getId = () => {
    //    var id = 1;
    //    if (props.id) {
    //        id = props.id;
    //    }
    //}
    //const createNewLicense = () => {
    //    createLicense({
    //        companyId: props.data.companyId,
    //        name: name,
    //        unit: unit,
    //    }).then((data) => {
    //        props.callback(data);
    //        toggle();
    //    }).catch((e) => {
    //        console.log(e);
    //        toggle();
    //    })
    //}
    var submitForm = function (e) {
        e.preventDefault();
        var licenseId = autoRef.current.getValue();
        subscription_1.purchaseLicense({
            licenseId: licenseId,
            unit: unit,
            companyId: companyId,
            userId: userId
        }).then(function (response) {
            var item = response.data;
            setUnit('');
            toggle();
            props.callback(item);
        }).catch(console.error);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(reactstrap_1.Button, { color: "secondary", onClick: toggle },
            React.createElement("a", { className: "padding-default" }, "+ New License")),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "New License"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, { autocomplete: "off" },
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                                React.createElement(AutoComplete_1.default, { ref: autoRef, className: "", onSearch: getLicenses, placeholder: "Name" }))),
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Unit" }, "Unit*"),
                                React.createElement(reactstrap_1.Input, { type: "number", name: "Unit", id: "Unit", placeholder: "Unit", onChange: function (e) { return setUnit(e.target.value); } })))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { type: "button", color: "secondary", onClick: function (e) { return submitForm(e); } }, "Confirm")))));
};
exports.default = AddNewLicense;
//# sourceMappingURL=AddNewLicense.js.map